import { Link } from "react-router-dom";

export default function BottomNav() {
  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        background: "#fff",
        borderTop: "1px solid #ddd",
        display: "flex",
        justifyContent: "space-around",
        padding: "10px"
      }}
    >
      <Link to="/">Home</Link>
      <Link to="/subjects">Subjects</Link>
      <Link to="/teachers">Teachers</Link>
      <Link to="/classes">Classes</Link>
    </div>
  );
}